/* Teresa Ramírez — JavaScript del tema (sin dependencias) */
(function () {
  'use strict';

  var theme = window.theme || {};
  var strings = theme.strings || {};
  var body = document.body;
  var overlay = document.querySelector('[data-overlay]');
  var openDrawer = null;

  /* ---------- Formato de precio (respeta el formato de la tienda) ---------- */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    format = format || theme.moneyFormat || '{{amount_with_comma_separator}} €';
    function delimit(number, precision, thousands, decimal) {
      if (isNaN(number) || number == null) return '0';
      number = (number / 100).toFixed(precision);
      var parts = number.split('.');
      var whole = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      return whole + (parts[1] ? decimal + parts[1] : '');
    }
    var match = format.match(/\{\{\s*(\w+)\s*\}\}/);
    var value = '';
    switch (match ? match[1] : 'amount_with_comma_separator') {
      case 'amount': value = delimit(cents, 2, ',', '.'); break;
      case 'amount_no_decimals': value = delimit(cents, 0, ',', '.'); break;
      case 'amount_no_decimals_with_comma_separator': value = delimit(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': value = delimit(cents, 2, "'", '.'); break;
      case 'amount_with_space_separator': value = delimit(cents, 2, ' ', ','); break;
      default: value = delimit(cents, 2, '.', ',');
    }
    return format.replace(/\{\{\s*\w+\s*\}\}/, value);
  }

  /* ---------- Drawers ---------- */
  function setDrawer(drawer, open) {
    if (!drawer) return;
    if (open) {
      if (openDrawer && openDrawer !== drawer) setDrawer(openDrawer, false);
      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      if (overlay) overlay.hidden = false;
      body.classList.add('is-locked');
      openDrawer = drawer;
      setTimeout(function () { drawer.focus(); }, 50);
    } else {
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      if (overlay) overlay.hidden = true;
      body.classList.remove('is-locked');
      if (openDrawer === drawer) openDrawer = null;
    }
    var toggles = document.querySelectorAll('[aria-controls="' + drawer.id + '"]');
    toggles.forEach(function (t) { t.setAttribute('aria-expanded', open ? 'true' : 'false'); });
  }

  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-menu-open]');
    if (t) { e.preventDefault(); setDrawer(document.querySelector('[data-menu-drawer]'), true); return; }

    t = e.target.closest('[data-cart-open]');
    if (t && theme.cartType === 'drawer' && document.querySelector('[data-cart-drawer]')) {
      e.preventDefault(); setDrawer(document.querySelector('[data-cart-drawer]'), true); return;
    }

    t = e.target.closest('[data-drawer-close]');
    if (t) { setDrawer(t.closest('.drawer'), false); return; }

    if (e.target.matches('[data-overlay]') && openDrawer) { setDrawer(openDrawer, false); return; }

    t = e.target.closest('[data-dialog-open]');
    if (t) {
      var dlg = document.getElementById(t.getAttribute('data-dialog-open'));
      if (dlg && typeof dlg.showModal === 'function') { dlg.showModal(); }
      return;
    }
    t = e.target.closest('[data-dialog-close]');
    if (t) { var d = t.closest('dialog'); if (d) d.close(); return; }

    if (e.target.tagName === 'DIALOG') { e.target.close(); return; }

    t = e.target.closest('[data-qty-change]');
    if (t) {
      e.preventDefault();
      changeLine(parseInt(t.getAttribute('data-line-index'), 10), parseInt(t.getAttribute('data-qty-change'), 10));
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && openDrawer) setDrawer(openDrawer, false);
  });

  /* ---------- Cesta (AJAX + Section Rendering API) ---------- */
  function updateCount(count) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
      el.hidden = !count;
    });
  }

  function refreshCartDrawer(open) {
    var root = (theme.routes && theme.routes.root) || '/';
    return fetch(root + '?sections=cart-drawer', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var html = data['cart-drawer'];
        if (!html) return;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('[data-cart-drawer-inner]');
        var current = document.querySelector('[data-cart-drawer-inner]');
        if (fresh && current) current.innerHTML = fresh.innerHTML;
        if (open) setDrawer(document.querySelector('[data-cart-drawer]'), true);
      })
      .then(function () { return fetch(((theme.routes && theme.routes.cart) || '/cart') + '.js', { credentials: 'same-origin' }); })
      .then(function (r) { return r.json(); })
      .then(function (cart) { updateCount(cart.item_count); })
      .catch(function () {});
  }

  function changeLine(line, quantity) {
    var url = (theme.routes && theme.routes.cartChange) || '/cart/change';
    fetch(url + '.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ line: line, quantity: Math.max(0, quantity) })
    }).then(function () { return refreshCartDrawer(false); });
  }

  /* ---------- Barra de anuncios ---------- */
  var ann = document.querySelector('[data-announcement]');
  if (ann) {
    var msgs = ann.querySelectorAll('.announcement__msg');
    if (msgs.length > 1) {
      var i = 0;
      setInterval(function () {
        msgs[i].classList.remove('is-active');
        i = (i + 1) % msgs.length;
        msgs[i].classList.add('is-active');
      }, 4000);
    }
  }

  /* ---------- Ficha de producto ---------- */
  function initProduct(section) {
    var form = section.querySelector('form[id^="ProductForm-"]');
    if (!form) return;
    var idInput = form.querySelector('[data-variant-id]');
    var addBtn = form.querySelector('[data-add-button]');
    var addLabel = form.querySelector('[data-add-label]');
    var errorEl = form.querySelector('[data-form-error]');
    var picker = section.querySelector('[data-variant-picker]');
    var jsonEl = section.querySelector('[data-product-json]');
    var product = jsonEl ? JSON.parse(jsonEl.textContent) : null;
    var sticky = section.querySelector('[data-sticky-atc]');
    var stickyBtn = section.querySelector('[data-sticky-button]');
    var stickyPrice = section.querySelector('[data-sticky-price]');
    var currentVariant = null;

    function selectedOptions() {
      if (!picker) return [];
      return Array.prototype.map.call(picker.querySelectorAll('fieldset[data-option-index]'), function (fs) {
        var checked = fs.querySelector('input:checked');
        return checked ? checked.value : null;
      });
    }

    function findVariant(opts) {
      if (!product || opts.indexOf(null) !== -1) return null;
      for (var v = 0; v < product.variants.length; v++) {
        var variant = product.variants[v];
        var ok = true;
        for (var o = 0; o < opts.length; o++) {
          if (variant.options[o] !== opts[o]) { ok = false; break; }
        }
        if (ok) return variant;
      }
      return null;
    }

    function updateAvailability(opts) {
      if (!picker || !product) return;
      picker.querySelectorAll('fieldset[data-option-index]').forEach(function (fs) {
        var idx = parseInt(fs.getAttribute('data-option-index'), 10);
        fs.querySelectorAll('input').forEach(function (input) {
          var available = product.variants.some(function (v) {
            if (!v.available || v.options[idx] !== input.value) return false;
            for (var o = 0; o < opts.length; o++) {
              if (o !== idx && opts[o] !== null && v.options[o] !== opts[o]) return false;
            }
            return true;
          });
          var label = fs.querySelector('label[for="' + input.id + '"]');
          if (label) label.classList.toggle('is-unavailable', !available);
        });
      });
    }

    function sizeMissing() {
      if (!picker) return false;
      var fs = picker.querySelector('[data-size-option]');
      return !!(fs && !fs.querySelector('input:checked'));
    }

    function render() {
      var opts = selectedOptions();
      updateAvailability(opts);
      if (picker) {
        picker.querySelectorAll('fieldset[data-option-index]').forEach(function (fs, n) {
          var label = fs.querySelector('[data-option-label]');
          if (label) label.textContent = opts[n] || '';
          if (opts[n]) fs.classList.remove('is-error');
        });
      }
      if (!product || !picker) return;

      currentVariant = findVariant(opts);
      if (currentVariant) {
        idInput.value = currentVariant.id;
        var priceWrap = section.querySelector('[data-product-price]');
        if (priceWrap) {
          var p = priceWrap.querySelector('[data-price]');
          var c = priceWrap.querySelector('[data-compare-price]');
          var b = priceWrap.querySelector('[data-price-badge]');
          var onSale = currentVariant.compare_at_price && currentVariant.compare_at_price > currentVariant.price;
          if (p) p.textContent = formatMoney(currentVariant.price);
          priceWrap.querySelector('.price').classList.toggle('price--sale', !!onSale);
          if (c) { c.hidden = !onSale; c.textContent = onSale ? formatMoney(currentVariant.compare_at_price) : ''; }
          if (b) {
            b.hidden = !onSale;
            b.textContent = onSale ? '-' + Math.floor((currentVariant.compare_at_price - currentVariant.price) * 100 / currentVariant.compare_at_price) + ' %' : '';
          }
        }
        if (stickyPrice) stickyPrice.textContent = formatMoney(currentVariant.price);
        addBtn.disabled = !currentVariant.available;
        addLabel.textContent = currentVariant.available ? strings.addToCart : strings.soldOut;
        if (stickyBtn) stickyBtn.textContent = currentVariant.available ? strings.addToCart : strings.soldOut;
        if (window.history && window.history.replaceState) {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', currentVariant.id);
          window.history.replaceState({}, '', url.toString());
        }
      } else {
        idInput.value = '';
        addBtn.disabled = false;
        addLabel.textContent = strings.addToCart;
        if (stickyBtn) stickyBtn.textContent = sizeMissing() ? strings.addToCart : strings.unavailable;
      }
    }

    if (picker) {
      picker.addEventListener('change', function () {
        var err = section.querySelector('[data-size-error]');
        if (err && !sizeMissing()) err.hidden = true;
        render();
      });
      render();
    }

    function showSizeError() {
      var fs = picker && picker.querySelector('[data-size-option]');
      var err = section.querySelector('[data-size-error]');
      if (fs) {
        fs.classList.add('is-error');
        fs.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
      if (err) err.hidden = false;
    }

    form.addEventListener('submit', function (e) {
      if (!idInput.value) {
        e.preventDefault();
        showSizeError();
        return;
      }
      if (theme.cartType !== 'drawer' || !window.fetch) return;
      e.preventDefault();
      errorEl.hidden = true;
      addBtn.disabled = true;
      var original = addLabel.textContent;
      addLabel.textContent = strings.adding;
      fetch(((theme.routes && theme.routes.cartAdd) || '/cart/add') + '.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Accept': 'application/json' },
        body: new FormData(form)
      })
        .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, data: j }; }); })
        .then(function (res) {
          if (!res.ok) throw new Error(res.data.description || res.data.message || strings.error);
          addLabel.textContent = original;
          addBtn.disabled = false;
          return refreshCartDrawer(true);
        })
        .catch(function (err) {
          errorEl.textContent = err.message || strings.error;
          errorEl.hidden = false;
          addLabel.textContent = original;
          addBtn.disabled = false;
        });
    });

    /* Barra fija de compra en móvil: visible siempre que el botón principal no esté en pantalla */
    if (sticky) {
      var ticking = false;
      var updateSticky = function () {
        ticking = false;
        var r = addBtn.getBoundingClientRect();
        var show = r.bottom < 0 || r.top > window.innerHeight;
        sticky.classList.toggle('is-visible', show);
        sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
      };
      window.addEventListener('scroll', function () {
        if (!ticking) { ticking = true; window.requestAnimationFrame(updateSticky); }
      }, { passive: true });
      updateSticky();
    }
    if (stickyBtn) {
      stickyBtn.addEventListener('click', function () {
        if (!idInput.value) { showSizeError(); return; }
        if (form.requestSubmit) form.requestSubmit(); else addBtn.click();
      });
    }

    /* Puntos de la galería en móvil */
    var track = section.querySelector('[data-gallery-track]');
    var dots = section.querySelectorAll('.gallery__dot');
    if (track && dots.length) {
      track.addEventListener('scroll', function () {
        var item = track.firstElementChild;
        var step = item ? item.getBoundingClientRect().width + 6 : track.clientWidth;
        var idx = Math.min(dots.length - 1, Math.round(track.scrollLeft / step));
        dots.forEach(function (d, n) { d.classList.toggle('is-active', n === idx); });
      }, { passive: true });
    }
  }


  /* ---------- Cabecera: cambia al hacer scroll ---------- */
  var header = document.querySelector('[data-header]');
  if (header) {
    var onScroll = function () { header.classList.toggle('is-scrolled', window.scrollY > 10); };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ---------- Aparición suave ---------- */
  function markLoaded(img) {
    if (img.complete && img.naturalWidth) { img.classList.add('is-loaded'); return; }
    img.addEventListener('load', function () { img.classList.add('is-loaded'); }, { once: true });
    img.addEventListener('error', function () { img.classList.add('is-loaded'); }, { once: true });
  }
  function initMotion(root) {
    root.querySelectorAll('.media__img, .gallery__img, .feature__img').forEach(markLoaded);
    var items = root.querySelectorAll('.reveal:not(.is-in)');
    if (!('IntersectionObserver' in window)) { items.forEach(function (el) { el.classList.add('is-in'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) { entry.target.classList.add('is-in'); io.unobserve(entry.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    items.forEach(function (el) { io.observe(el); });
  }
  initMotion(document);
  document.addEventListener('shopify:section:load', function (e) { initMotion(e.target); });

  document.querySelectorAll('[data-product-section]').forEach(initProduct);

  /* Editor de temas: reinicializar al editar secciones */
  document.addEventListener('shopify:section:load', function (e) {
    var s = e.target.querySelector('[data-product-section]');
    if (s) initProduct(s);
  });
})();
